import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles, manager, teamAdmin } from '../../constants/appConstants';
import { activityLoader } from '../loaders/activity';
import PageLoader from '../loaders/pageLoader';
import { requestsLoader } from '../loaders/requests';
import { rootLoader } from '../loaders/rootLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../Root';

const ActivityPage = lazy(() => import('../../components/pages/activity'));
const RequestPage = lazy(() => import('../../components/pages/request'));

const activityPath = '/activity' as const;

export const activityRoutes = {
	path: activityPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<ActivityPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, activityData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					activityLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...activityData,
				};
			},
		},
		{
			path: ':approvalId',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<RequestPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, requestData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					requestsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...requestData,
				};
			},
		},
		{
			path: 'approved',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<ActivityPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, activityData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					activityLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...activityData,
				};
			},
		},
		{
			path: 'declined',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<ActivityPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, activityData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					activityLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...activityData,
				};
			},
		},
		{
			path: 'canceled',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<ActivityPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, activityData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					activityLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...activityData,
				};
			},
		},
	],
};
